import React, { useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { useLazyDownloadDocumentByKeyQuery } from '../../../../../api/endpoints/documentContent';
import DocumentDownloadService from '../../../../../utils/documentDownloadService';
import { useLanguage } from '../../../../../contexts/LanguageContext';

/**
 * Shared "click to download a single document" header used by the VAF and PSI
 * screens (previously each had its own near-identical copy under
 * hooks/useDocumentProcess.js, despite exporting a component, not a hook).
 *
 * All display text is driven by i18n keys passed as props, so each screen
 * keeps its own wording without duplicating the download logic.
 */
const DocumentDownloadHeader = ({ fileKey, documentLabelKey, downloadingMessageKey, successMessageKey, errorMessageKey }) => {
    const toast = useRef(null);
    const { th } = useLanguage();

    const [downloadService] = useState(() => new DocumentDownloadService(toast));

    const [triggerDownloadByKey] = useLazyDownloadDocumentByKeyQuery();

    const handleDownloadDocument = async (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        toast.current?.show({
            severity: 'info',
            summary: th('common.downloading'),
            detail: th(downloadingMessageKey),
            life: 3000
        });

        try {
            await downloadService.downloadByKey(triggerDownloadByKey, fileKey, null, {
                successMessage: th(successMessageKey),
                errorMessage: th(errorMessageKey)
            });
        } catch (error) {
            toast.current?.show({
                severity: 'error',
                summary: th('common.error'),
                detail: `${th(errorMessageKey)}: ${error.message || th('common.unknownError')}`,
                life: 4000
            });
        }
    };

    return (
        <>
            <Toast ref={toast} />

            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    transition: 'background-color 0.2s'
                }}
                onClick={handleDownloadDocument}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f0f0f0')}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
                <img
                    src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                    alt="Dosya simgesi"
                    style={{
                        width: '40px',
                        height: '40px',
                        cursor: 'pointer'
                    }}
                />
                <span
                    style={{
                        marginLeft: '10px',
                        fontWeight: 'bold',
                        color: '#495057'
                    }}
                >
                    {th(documentLabelKey)}
                </span>
            </div>
        </>
    );
};

export default DocumentDownloadHeader;
